import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  banner: {
    boxSizing: 'border-box',
    width: '100%',
    background: C.cardBg,
    border: `1px solid ${C.divider}`,
    borderRadius: 8,
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },
  borderAlert: { borderColor: C.bannerBorder },
  borderSuccess: { borderColor: C.successText },
  borderError: { borderColor: C.dangerDot },
  borderNeutral: { borderColor: C.divider },
  topRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 24,
    width: '100%',
  },
  statusGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
  },
  statusLabel: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.darkText,
  },
  divider: {
    width: 1,
    alignSelf: 'stretch',
    backgroundColor: C.darkText,
    opacity: 0.2,
    flexShrink: 0,
  },
  messageGroup: {
    flex: '1 1 0',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    alignItems: 'flex-start',
  },
  messageText: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: C.darkText,
  },
  amountGroup: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    textAlign: 'right',
    alignItems: 'flex-end',
  },
  amountLabel: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.mutedText,
  },
  amountValue: {
    fontSize: 22,
    fontWeight: 500,
    lineHeight: '28px',
    letterSpacing: '0.15px',
    color: C.darkText,
  },
  amountSymbol: {
    fontSize: 18,
    fontWeight: 500,
    lineHeight: '27px',
    color: C.mutedText,
    marginRight: 1,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  actionButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 12px 4px 4px',
    borderRadius: 8,
    border: `1px solid ${C.stepUpcomingBorder}`,
    background: C.cardBg,
    cursor: 'pointer',
    '& span': {
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: C.strongText,
    },
    '& svg': { fontSize: 12, color: C.strongText },
  },
  gradientIcon: {
    width: 12,
    height: 12,
  },
}))
